import React from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button, Divider, Stack, Typography } from "@mui/material";

import { State } from ".";
import { Contact } from "./Contact";
import { useContactHooks } from "./hooks/use-contact-hooks";

interface Props {
  state: State;
  setState: React.Dispatch<React.SetStateAction<State>>;
  viewOnly: boolean;
}

export const ContactList: React.FC<Props> = ({ state, setState, viewOnly }) => {
  const { updateContact, updateContactVisibility, addContact, deleteContact } = useContactHooks({ setState });

  return (
    <Stack>
      {Boolean(state.contact.length) &&
        state.contact.map((contact) => (
          <Stack key={contact.id} gap="20px">
            <Contact
              contact={contact}
              onChange={updateContact}
              onVisibility={updateContactVisibility}
              disabled={viewOnly}
              deleteContact={deleteContact}
            />
            <Divider sx={{ borderColor: "#DBE8F5", marginBottom: "20px" }} />
          </Stack>
        ))}

      {!viewOnly && (
        <Button
          variant="text"
          sx={{ background: "#f0f0f0", color: "#071F35", maxWidth: "160px", padding: "4px 10px" }}
          onClick={addContact}
        >
          <AddCircleOutlineIcon />
          <Typography fontSize="12px" sx={{ color: "#071F35" }}>
            Add contact
          </Typography>
        </Button>
      )}
    </Stack>
  );
};
